module.exports = __webpack_public_path__ + "img/indy.5a35e79.jpg";